<xena-modal label="Create default margin" i18n-label="@@defaultMargin_modal_label" [open]="open">
  <form [formGroup]="form">
    <span class="d-flex justify-content-between">
      <xena-input class="max-input-size" label="From amount" i18n-label="@@defaultMargin_from_amount_label" [number]
        alignment="right" onfocus="this.getInputElement().then(i => i.select())" formControlName="fromAmount">
        <span slot="error-text" *ngIf="form.get('fromAmount').hasError('min')" i18n="@@defaultMargin_from_amount_validate">Negative number not allowed</span>
      </xena-input>
      <xena-input class="max-input-size" label="Marging %" i18n-label="@@defaultMargin_margin_percentage_label" [number]
        alignment="right" onfocus="this.getInputElement().then(i => i.select())" formControlName="margin">
        <span slot="suffix">%</span>
      </xena-input>
    </span>
  </form>

  <xena-button slot="footer" (click)="cancel()" mode="ghost" i18n="@@defaultMargin_cancelButton">Cancel</xena-button>
  <xena-button slot="footer" *ngIf="id === 0" (click)="save()" type="primary" [disabled]="form.invalid" i18n="@@defaultMargin_createButton" [loading]="saving">Create</xena-button>
  <xena-button slot="footer" *ngIf="id !== 0" (click)="save()" type="primary" [disabled]="form.invalid" i18n="@@defaultMargin_updateButton" [loading]="saving">Update</xena-button>
</xena-modal>
